<template>
  <div>
    <CCard>
      <ProcessBarModal
          :show-modal="showModal"
          :step="step"
          :error-text="downloadError"
          :progress="progress"
          :steps-text="{creating: 'Report creation', success: 'Report created', error: 'Something went wrong'}"
          @close="() => showModal = false"
          :title="$t('Downloading file')"
      />
      <CCardHeader>
        {{ $t('Reports') }}
      </CCardHeader>
      <CCardBody>
        <CRow class="w-100">
          <ul>
            <li v-for="link in links" v-if="shouldShowLink(link.label)">
              <CButton
                  color="link"
                  class="font-2xl custom-links"
                  @click="downloadFile(link.report)"
              >
                {{ $t(`${link.label}`) }}
                {{ link.sub_label ? link.sub_label : '' }}
              </CButton>
            </li>
          </ul>
        </CRow>
      </CCardBody>
    </CCard>
  </div>

</template>

<script>
import {CAMPAIGN_REPORTS_ENDPOINTS} from "@/services/campaign_reports";
import {CampaignServices} from "@/services/campaigns";
import moment from "moment";

import Task from "@/services/task";
import ProcessBarModal from "@/components/ProcessBarModal.vue";
import { request } from "@/utils/request";

export default {
  name: "Reports",
  components: {ProcessBarModal},
  data() {
    return {
      showModal: false,
      step: '',
      progress: 0,
      downloadError: '',
      CAMPAIGN_REPORTS_ENDPOINTS,
      campaign_id: this.$route.params.campaignId,
      isClosed: false,
      linksToHideOnClose: [
        "Control report", "Statistics report"
      ],
      links: [
        {
          label: "Collected premiums",
          sub_label: "N-1",
          report: 'collected_premiums_n_1'
        },
        {
          label: "Estimated premiums ",
          sub_label: "N+1",
          report: 'estimates_n_1'
        },
        {
          label: "Control report",
          report: "control"
        },
        {
          label: "Statistics report",
          report: 'statistics'
        },
        {
          label: "Risk File I and Appendix II",
          report: 'risk_file_and_annexe_ii'
        }
      ]
    }
  },
  computed: {
    formattedDate() {
      return new Date().toJSON().slice(0, 10).replace(/-/g, "-");
    },
  },
  async mounted() {
    this.campaign_id = this.$route.params.campaignId;

    const campaign = await CampaignServices.fetchCampaign(this.campaign_id);
    const campaign_date_end = moment(campaign.data.date_end).format("YYYY-MM-DD")
    this.isClosed = campaign_date_end <= this.formattedDate;
  },
  methods: {
    shouldShowLink(name) {
      if (this.linksToHideOnClose.includes(name)) {
        return this.isClosed
      }
      return true;
    },
    async downloadFile(selected_report) {
      this.downloadError = '';
      this.step = 'creating'
      this.progress = 0;
      this.showModal = true;

      this.progress = 25
      const { data } = await request({
        url: this.CAMPAIGN_REPORTS_ENDPOINTS.reports,
        query: {
          campaign_id: this.campaign_id,
          selected_report,
          language: this.$store.state.language
        }
      });
      this.progress = 50;
      if (data && !data.detail) {
        this.progress = 75;
        const task = new Task(data, 'xlsx');
        task.on('result', (result) => {
          if (result?.error) {
            this.step = 'error'
            this.uploadError = result.error
          }
          this.progress = 100;
          this.step = 'success';
          this.$downloadFile({ response: result })
        })

        task.on('error', (error) => {
          this.step = 'error'
          this.downloadError = error
        })
      }
      else {
        this.step = 'error'
        this.downloadError = data.detail || ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.custom-links {
  color: $primary;
  text-decoration: underline;

  &:hover {
    color: $text-secondary;
  }
}
</style>
